import { Application } from '@hotwired/stimulus';

const application = Application.start();

Object.entries(
  import.meta.glob('@controllers/algolia/**/*_controller.js', { eager: true })
).forEach(([path, module]) => {
  const filename = path.split('/').pop();
  const identifier = filename.split('_controller.js').shift();
  application.register(identifier, module.default);
});
